import * as yup from 'yup';
import { TranslateFn } from '../../../library/validationRules';

/** What the ticks amount to: the catalogue lines this therapist can be booked for. */
export interface TherapistServicesFormValues {
    catalogTypeIds: number[];
}

/**
 * Nothing is refused here, and that is the rule rather than an omission: a therapist with
 * no lines ticked is a real state -- somebody newly invited, before anyone has said what
 * they do -- and the dialog's own Save is gated on having changed something, not on having
 * chosen something.
 *
 * It goes through the same schema-and-resolver path as every other form anyway, so the
 * ticks live in one place and the dialog has no bespoke state to reset.
 */
export const createTherapistServicesSchema = (_translate: TranslateFn) => yup.object({
    catalogTypeIds: yup.array().of(yup.number().defined()).defined(),
});
